/* The home hero's looping video (Round 14; markup in sections/sp-campaign.liquid, styles in sp-home.css). Loaded only
   when the hero has a video (and in the theme editor). The photo underneath is the poster: nothing here runs until
   the page has loaded and the browser is idle, so the photo is what paints first. Then the file for this screen
   (the phone file below 750px, else the wide one; none means the photo stays) is set and played, silent and looping,
   and the hero gets .is-playing once frames arrive, which fades the video in over the photo. Never with reduced
   motion, data saver or a slow connection (2G or 3G as the browser reports it). The button pauses and plays; a
   shopper's pause holds until they press play again. Off screen the video rests and resumes when it comes back.
   Round 21: on laptops and desktops the banner is shorter than the wide film, so the film is cropped shot by shot:
   data-shots ("0=100, 2.5=0, …": the second each shot starts = the height to keep, 0 top, 100 bottom) sets the
   video's vertical position on the frame where each shot begins (requestVideoFrameCallback, which reports the time
   of the frame just shown). Tablets and phones show the whole film, so they keep the stylesheet's position. */
const PHONE = window.matchMedia('(max-width: 749px)');
const BANNER = window.matchMedia('(min-width: 990px)');
const CALM = window.matchMedia('(prefers-reduced-motion: reduce)');

function followShots(video) {
  const shots = (video.dataset.shots || '')
    .split(',')
    .map((pair) => pair.split('=').map(Number))
    .filter(([at, height]) => at >= 0 && height >= 0 && height <= 100)
    .sort((a, b) => a[0] - b[0]);
  if (!shots.length || !('requestVideoFrameCallback' in video)) return;
  let shown = null;
  const onFrame = (now, frame) => {
    let height = null;
    if (BANNER.matches) for (const [at, h] of shots) if (frame.mediaTime + 0.001 >= at) height = h;
    if (height !== shown) {
      video.style.objectPosition = height === null ? '' : `50% ${height}%`;
      shown = height;
    }
    video.requestVideoFrameCallback(onFrame);
  };
  video.requestVideoFrameCallback(onFrame);
}

const allowed = () => {
  if (CALM.matches) return false;
  const c = navigator.connection;
  return !(c && (c.saveData || /(^|-)2g$|^3g$/.test(c.effectiveType || '')));
};

function setUp(hero) {
  const video = hero.querySelector('[data-sp-hero-video]');
  const toggle = hero.querySelector('[data-sp-hero-toggle]');
  if (!video || video.dataset.spReady) return;
  video.dataset.spReady = '1';
  let held = false; // the shopper pressed pause
  let seen = true;

  const show = (playing) => {
    hero.classList.toggle('is-playing', playing);
    if (toggle) toggle.hidden = !playing && !held;
  };
  const label = () => {
    if (!toggle) return;
    toggle.toggleAttribute('data-paused', held);
    toggle.setAttribute('aria-label', held ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
  };
  const run = () => {
    if (!held && seen && video.getAttribute('src')) video.play().catch(() => {});
  };
  const choose = () => {
    const src = allowed() ? ((PHONE.matches ? video.dataset.srcPhone : video.dataset.src) || '').trim() : '';
    if (!src) {
      video.pause();
      video.removeAttribute('src');
      video.load();
      held = false;
      show(false);
      return;
    }
    if (video.getAttribute('src') !== src) {
      video.src = src;
      video.muted = true;
    }
    run();
  };

  video.muted = true;
  followShots(video);
  video.addEventListener('playing', () => show(true));
  video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; });
  toggle?.addEventListener('click', () => {
    held = !held;
    label();
    if (held) video.pause();
    else run();
  });
  new IntersectionObserver(([entry]) => {
    seen = entry.isIntersecting;
    if (seen) run();
    else video.pause();
  }).observe(hero);
  PHONE.addEventListener('change', choose);
  CALM.addEventListener('change', choose);
  choose();
}

const start = () => document.querySelectorAll('.sp-hero').forEach(setUp);
const later = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 2000 }) : setTimeout(start, 200));
if (document.readyState === 'complete') later();
else window.addEventListener('load', later, { once: true });
document.addEventListener('shopify:section:load', start);
